import { FieldBase } from '@/components/form/fieldBase';
import { useFieldContext } from '@/components/form/formHooks';
import { FieldProps } from '@/components/form/types';
import { Input, InputProps } from '@/components/ui/input';

export function FieldTextInput({
  label,
  description,
  isRequired,
  placeholder,
  className,
  infoText,
  ...inputProps
}: FieldProps & InputProps) {
  const field = useFieldContext<string>();
  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      infoText={infoText}>
      <Input
        id={field.name}
        placeholder={placeholder}
        autoComplete="off"
        className={`h-10 ${className ?? ''}`}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={() => {
          field.setValue(field.state.value.trim() ?? '');
          field.handleBlur();
        }}
        {...inputProps}
      />
    </FieldBase>
  );
}
